import stockin from '@/api/stock-in'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  edit_data: {},
  products: [],
  suppliers: [],
  uoms: [],
  wareHouses: [],
  POLists: [],
  exchangeRate: '',
  date_from: moment().add(-7, 'Days').format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY'),
  branch_id: null
}

export const getters = {
  uomGetter: state => ObjectRow => {
    let result = state.products.filter(
      p => p.product_id == ObjectRow.product_id
    )
    if (result.length > 0) {
      return state.uoms.filter(u => u.uom_cat_id == result[0].uom_cat_id)
    }
    return []
  },
  productPrice: state => (productId, uomId) => {
    try {
      return _.flatten(
        state.products.find(p => p.product_id == productId).sale_code
      ).find(sc => sc.uom_id == uomId).product_price
    } catch (e) {
      return ''
    }
  },
  totalAmount: (state, getters) => detail => {
    try {
      let amount = detail.cost * detail.qty,
        discount_amount = (amount * detail.discount_rate) / 100,
        vat_amount = ((amount - discount_amount) * detail.vat_rate) / 100

      return _.ceil(amount - discount_amount + vat_amount, 2)
    } catch (e) {
      return 0
    }
  },
  subTotal: (state, getters) => details => {
    return _.ceil(
      _.sumBy(details, detail => getters.totalAmount(detail)),
      2
    )
  }
}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA (state, data) {
    state.edit_data = data
  },
  SET_PRODUCT (state, data) {
    state.products = data
  },
  SET_SUPPLIER (state, data) {
    state.suppliers = data
  },
  SET_UOM (state, data) {
    state.uoms = data
  },
  SET_WAREHOUSE (state, data) {
    state.wareHouses = data
  },
  SET_EXCHANG_RATE (state, data) {
    state.exchangeRate = data
  },
  SET_PO_List (state, data) {
    state.POLists = data
  },
  SET_DATE_FROM (state, date) {
    state.date_from = date
  },
  SET_DATE_TO (state, date) {
    state.date_to = date
  },
  SET_BRANCH_ID (state, data) {
    state.branch_id = data
  }
}

export const actions = {
  fetch (context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        date_from: context.state.date_from,
        date_to: context.state.date_to,
        all_branch: Array.isArray(context.state.branch_id)
          ? context.state.branch_id.length
            ? undefined
            : true
          : true
      },
      attrubutes
    )
    return stockin.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store (context, data) {
    return stockin.store(data)
  },

  update (context, data) {
    return stockin.update(data)
  },
  destroy (context, id) {
    return stockin.destroy(id)
  },

  async getPOResource (context, id) {
    return await stockin.getPOResource(id)
  },

  async find (context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await stockin.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  async dataBeforeCreate (context) {
    if (!context.state.products.length > 0) {
      let response = await stockin.getProduct()
      context.commit('SET_PRODUCT', response)
    }
    if (!context.state.suppliers.length > 0) {
      let response = await stockin.getSupplier()
      context.commit('SET_SUPPLIER', response)
    }
    if (!context.state.uoms.length > 0) {
      let response = await stockin.getUOM()
      context.commit('SET_UOM', response)
    }
    if (!context.state.wareHouses.length > 0) {
      let response = await stockin.getWareHouse()
      context.commit('SET_WAREHOUSE', response)
    }
    if (!context.state.POLists.length > 0) {
      let response = await stockin.getPOList()
      context.commit('SET_PO_List', response)
    }
    if (!context.state.exchangeRate) {
      let response = await stockin.getExchangRate()
      context.commit('SET_EXCHANG_RATE', response.exchange_rate)
    }
  },
    previewPdf(context, id) {
    return stockin.printPDF(id)
  },
}
